/* eslint-disable */
/*
  🚨🚨🚨
  IMPORTANT: 
    This code comes from the jSignature repository and it was barely modified.
    https://github.com/brinley/jSignature/blob/bd6312e98026a5e4220f68500eb1fbc8738da687/src/plugins/jSignature.CompressorBase30.js#L3

    JSignature saves the data points in a custom base30 format, with this code we can encode/decode those points,
    this way we can ensure retrocompatibility between the signatures created in the V3 and the ones created in the new builder.

    Also worth to mention that because of the MIT License we should KEEP the copyright notice.
  🚨🚨🚨
*/

/** @preserve
jSignature v2 jSignature's custom "base30" format export and import plugins.

*/
/**
Copyright (c) 2011 Willow Systems Corp http://willow-systems.com
MIT License <http://www.opensource.org/licenses/mit-license.php>
*/

const chunkSeparator = '_';
const charmap: any = {}; // {'1':'g','2':'h','3':'i','4':'j','5':'k','6':'l','7':'m','8':'n','9':'o','a':'p','b':'q','c':'r','d':'s','e':'t','f':'u','0':'v'}
const charmapReverse: any = {}; // will be filled by 'uncompress*" function
// need to split below for IE7 (possibly others), which does not understand string[position] it seems (returns undefined)
const allchars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWX'.split('');
const bitness = allchars.length / 2;
const minus = 'Z';
const plus = 'Y';

for (let i = bitness - 1; i > -1; i--) {
  charmap[allchars[i]] = allchars[i + bitness];
  charmapReverse[allchars[i + bitness]] = allchars[i];
}
const remapTailChars = function (number: any) {
  // for any given number as string, returning string with trailing chars remapped something like so:
  // '345' -> '3de'
  const chars = number.split('');
  const l = chars.length;
  // we are skipping first char. standard hex number char = delimiter
  for (let i = 1; i < l; i++) {
    chars[i] = charmap[chars[i]];
  }
  return chars.join('');
};
const compressstrokeleg = function (data: any) {
  // we convert half-stroke (only 'x' series or only 'y' series of numbers)
  // data is like this:
  // [517,516,514,513,513,513,514,516,519,524,529,537,541,543,544,544,539,536]
  // that is converted into this:
  // "5agm12100p1235584210m53"
  // each number in the chain is converted such:
  // - find diff from previous number
  // - first significant digit is kept as digit char. digit char = start of new number.
  // - consecutive numbers are mapped to letters, where 1 to 9 are A to I, 0 is O
  // Sign changes are denoted by "P" - plus, "M" for minus.
  const answer: string[] = [];
  let lastwhole = 0;
  let lastpolarity = 1;
  const l = data.length;
  let nwhole;
  let n;
  let absn;

  for (let i = 0; i < l; i++) {
    // we start with whole coordinates for each point
    // coords are converted into series of vectors:
    // [512, 514, 520]
    // [512, +2, +6]
    nwhole = Math.round(data[i]);
    n = nwhole - lastwhole;
    lastwhole = nwhole;

    // inserting sign change when needed.
    if (n < 0 && lastpolarity > 0) {
      lastpolarity = -1;
      answer.push(minus);
    } else if (n > 0 && lastpolarity < 0) {
      lastpolarity = 1;
      answer.push(plus);
    }

    // since we have dealt with sign. let's absolute the value.
    absn = Math.abs(n);
    // adding number to list  We convert these to Hex before storing on the string.
    if (absn >= bitness) {
      answer.push(remapTailChars(absn.toString(bitness)));
    } else {
      answer.push(absn.toString(bitness));
    }
  }
  return answer.join('');
};
const uncompressstrokeleg = function (datastring: any) {
  // we convert half-stroke (only 'x' series or only 'y' series of numbers)
  // datastring like this:
  // "5agm12100p1235584210m53"
  // is converted into this:
  // [517,516,514,513,513,513,514,516,519,524,529,537,541,543,544,544,539,536]
  // each number in the chain is converted such:
  // - digit char = start of new whole number. Alpha chars except "p","m" are numbers in hiding.
  //   These consecutive digist expressed as alphas mapped back to digit char.
  //   resurrected number is the diff between this point and prior coord.
  // - running polaritiy is attached to the number.
  // - we undiff (signed number + prior coord) the number.
  // - if char 'm','p', flip running polarity
  const answer: any[] = [];
  const chars = datastring.split('');
  const l = chars.length;
  let ch;
  let polarity = 1;
  let partial: any[] = [];
  let preprewhole = 0;
  let prewhole;
  for (let i = 0; i < l; i++) {
    ch = chars[i];
    if (ch in charmap || ch === minus || ch === plus) {
      // this is new number - start of a new whole number.
      // before we can deal with it, we need to flush out what we already
      // parsed out from string, but keep in limbo, waiting for this sign
      // that prior number is done.
      // we deal with 3 numbers here:
      // 1. start of this number - a diff from previous number to
      //    whole, new number, which we cannot do anything with cause
      //    we don't know its ending yet.
      // 2. number that we now realize have just finished parsing = prewhole
      // 3. number we keep around that came before prewhole = preprewhole

      if (partial.length !== 0) {
        // yep, we have some number parts in there.
        prewhole = parseInt(partial.join(''), bitness) * polarity + preprewhole;
        answer.push(prewhole);
        preprewhole = prewhole;
      }

      if (ch === minus) {
        polarity = -1;
        partial = [];
      } else if (ch === plus) {
        polarity = 1;
        partial = [];
      } else {
        // now, let's start collecting parts for the new number:
        partial = [ch];
      }
    } /* alphas replacing digits */ else {
      // more parts for the new number
      partial.push(charmapReverse[ch]);
    }
  }
  // we always will have something stuck in partial
  // because we don't have closing delimiter
  answer.push(parseInt(partial.join(''), bitness) * polarity + preprewhole);

  return answer;
};

export const jSignatureBase30Encode = function (data: any) {
  const answer: string[] = [];
  const l = data.length;
  let stroke;
  for (let i = 0; i < l; i++) {
    stroke = data[i];
    answer.push(compressstrokeleg(stroke.x));
    answer.push(compressstrokeleg(stroke.y));
  }
  return answer.join(chunkSeparator);
};
export const jSignatureBase30Decode = function (datastring: any) {
  const data: any[] = [];
  const chunks = datastring.split(chunkSeparator);
  const l = chunks.length / 2;
  for (let i = 0; i < l; i++) {
    data.push({
      x: uncompressstrokeleg(chunks[i * 2]),
      y: uncompressstrokeleg(chunks[i * 2 + 1])
    });
  }
  return data;
};
